import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Audience() {
  const items = ['Cambiar de vida', 'Trabajar viajando', 'Ganar en dólares', 'Entrar a la industria náutica', 'Tener libertad geográfica', 'Salir de la rutina', 'Ahorrar todo el dinero que ganan'];
  return <section className="bg-white py-20" data-id="element-11">
      <div className="container mx-auto px-4" data-id="element-12">
        <div className="max-w-4xl mx-auto" data-id="element-13">
          <FadeIn data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-navy-950 mb-12" data-id="element-15">
              Ideal para personas que quieren:
            </h2>
          </FadeIn>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-16">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-17">
                <div className="flex items-center gap-4 p-6 rounded-2xl bg-gray-50 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-18">
                  <CheckCircle2 className="w-8 h-8 text-gold-500 flex-shrink-0" data-id="element-19" />
                  <span className="text-xl font-medium text-navy-900" data-id="element-20">
                    {item}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}